import {Injectable, Injector} from "@angular/core";
import {BaseListService, BatchResponse} from "app/services/domain/base.service";
import * as Models from "app/services/proxy/model/models";

@Injectable()
export class BillingPlanDefinitionListService extends BaseListService<Models.BillingPlanDefinitionListRequest, Models.BatchRequest, Models.BillingPlanDefinition>
{
    constructor(inj: Injector)
    {
        super(inj, Models.BillingPlanDefinition, 1000);
    }

    protected createBatchRequest(listReq: Models.BillingPlanDefinitionListRequest,
                                 ids: string[]): Models.BatchRequest
    {
        // TODO
        return undefined;
    }

    protected getBatchResponseImpl(req: Models.BatchRequest): Promise<BatchResponse<Models.BillingPlanDefinition>>
    {
        // TODO
        return Promise.resolve(undefined);
    }

    public list(listReq: Models.BillingPlanDefinitionListRequest): Promise<Models.ListResponse>
    {
        // TODO
        return Promise.resolve(undefined);
    }
}
